import { render, staticRenderFns } from "./SendSmsInput.vue?vue&type=template&id=aebc879a&scoped=true"
import script from "./SendSmsInput.vue?vue&type=script&lang=js"
export * from "./SendSmsInput.vue?vue&type=script&lang=js"
import style0 from "./SendSmsInput.vue?vue&type=style&index=0&id=aebc879a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebc879a",
  null
  
)

export default component.exports